// src/view/admin/did/components/DIDFormDialog.jsx

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Stack,
  Alert,
  Autocomplete,
  Divider,
  Typography,
} from "@mui/material";

import { Save, X } from "lucide-react";

export const DIDFormDialog = ({
  open,
  onClose,
  onSubmit,
  formValues,
  onFormChange,
  editingDid,
  saving,
  error,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      sx={{
        borderRadius: 3,
      }}
    >
      <DialogTitle>
        <Typography variant="h6" fontWeight={700}>
          {editingDid ? "Edit DID" : "Add DID"}
        </Typography>
      </DialogTitle>

      <Divider />

      <DialogContent>
        <Stack spacing={3}>
          {error && <Alert severity="error">{error}</Alert>}

          <TextField
            label="DID Number"
            value={formValues.did_alias}
            onChange={(e) => onFormChange("did_alias", e.target.value)}
            fullWidth
            required
          />

          <Autocomplete
            options={["IND", "UAE", "USA"]}
            value={formValues.country || ""}
            onChange={(e, newValue) => onFormChange("country", newValue || "")}
            renderInput={(params) => (
              <TextField {...params} label="Country" required />
            )}
          />

          <FormControl fullWidth>
            <Select
              value={formValues.did_isAvailable}
              onChange={(e) => onFormChange("did_isAvailable", e.target.value)}
            >
              <MenuItem value="yes">Available</MenuItem>
              <MenuItem value="no">Unavailable</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          px: 3,
          py: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          startIcon={<X />}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          startIcon={<Save />}
          disabled={saving}
        >
          {saving ? "Saving..." : editingDid ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
